module.exports = __webpack_public_path__ + "static/media/top-button.615a5c09.svg";